<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="用户名"
                  required
                  :rules="rules.required"
                  v-model="item.username"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="密码"
                  type="password"
                  :rules="rules.password"
                  v-model="item.password"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="密码确认"
                  type="password"
                  :rules="rules.rePassword"
                  v-model="item.rePassword"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="电子邮箱"
                  :rules="rules.email"
                  v-model="item.email"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="联系电话"
                  :rules="rules.phone"
                  v-model="item.phone"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/user';

  export default {
    mixins: [mixin.edit(baseUri)],
    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          "username": "",
          "password": "",
          "rePassword":"",
          "email": "",
          "phone": ""
        },

        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。',
            v => (v && v.length <= 20) || '长度必须小于20个字符。'
          ],
          password: [
            v => !!v || '必填项。',
            v => (v && v.length <= 20) || '长度必须小于20个字符。',
            v => (v && /^[^\s]+$/.test(v)) || '密码不能包含空白字符.',
            v => (v && window.xutil.passwdStrength(v) === 'strong') || '密码为弱口令，密码必须包含小写字母、大写字母、数字和特殊符号，且长度不少于8个字符'
          ],
          rePassword: [
            v => !!v || '必填项。',
            v => (v && v.length <= 20) || '长度必须小于20个字符。',
            v => (v && this.item.password === v) || '两次输入的密码不一致.'
          ],
          email: [
            v => (!v || /^[\w.\-_]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/ig.test(v)) || '邮箱格式不正确。'
          ],
          phone: [
            v =>
              (
                v &&
                (/(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/.test(v))
              ) || '电话号码格式不正确，请输入正确的手机号码，或固定电话号码.'
          ]
        }
      }
    },

    methods: {
      // after save
      afterSave(){
        this.$store.commit("updateUser", Object.assign({}, this.item));
      },
      // mixin 加载数据后调用
      beforeSendData(data) {
        Object.assign(data, this.item);
      }
    }
  }
</script>
